// export var host = 'http://localhost:8000';
export var host = 'https://be.inalife.id';

export var endpoint = {
    'certificate.download' : host + '/certificate/download',
    'index': host + '/api/v1',
    'auth': host + '/api/v1/auth',
    'login': host + '/api/v1/auth/login',
    'password': host + '/api/v1/password',
    'register': host + '/api/v1/auth/register',
    'profile': host + '/api/v1/auth/profile',
    'role': host + '/api/v1/role',
    'permission': host + '/api/v1/role/permission',
    'share': host + '/api/v1/share',
    'share.period': host + '/api/v1/share/period',
    'share.purchase': host + '/api/v1/share/purchase',
    'income.statement': host + '/api/v1/income/statement',
    'investor': host + '/api/v1/investor',
    'transaction': host + '/api/v1/transaction',
    'marketing': host + '/api/v1/marketing',
    'withdraw': host + '/api/v1/withdraw',
    'voucher-purchase': host + '/api/v1/voucher-purchase',
    'notification': host + '/api/v1/notification',
    'wallet': host + '/api/v1/wallet',
    'user': host + '/api/v1/user',
    'close.account': host + '/api/v1/close-account',
    'close.account.visibility': host + '/api/v1/close-account/visibility',
    'close.account.account-info': host + '/api/v1/close-account/account-info',
    'close.account.account-info-by-user': host + '/api/v1/close-account/account-info-by-user',
    'close.account.form-data': host + '/api/v1/close-account/form-data',
    'close.account.my-close-account': host + '/api/v1/close-account/my-close-account',
    'close.account.form-data-for-investor': host + '/api/v1/close-account/form-data-for-investor',
    'close.account.submit-form': host + '/api/v1/close-account/submit-form',
    'close.account.update': host + '/api/v1/close-account/update/:id',
    'close.account.create-for-investor': host + '/api/v1/close-account/create-for-investor',
    'close.account.accounts': host + '/api/v1/close-account/accounts',
    'close.account.account-detail': host + '/api/v1/close-account/account-detail/:id',
    'close.account.process-liquidation': host + '/api/v1/close-account/process-liquidation/:id',
};